import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './ChatDropdown.scss';

function ChatDropdown({ 
  title, 
  subtitle, 
  children, 
  className, 
  showHeader, 
  showFooter, 
  footerContent 
}) {
  // Only show header if explicitly requested or if title/subtitle provided
  const shouldShowHeader = showHeader || title || subtitle;

  const dropdownClasses = classNames('chat-dropdown', className);

  return (
    <div className={dropdownClasses}>
      {shouldShowHeader && (
        <div className="chat-dropdown__header">
          <div className="chat-dropdown__header-content">
            {title && <h3 className="chat-dropdown__title">{title}</h3>}
            {subtitle && <p className="chat-dropdown__subtitle">{subtitle}</p>}
          </div>
        </div>
      )}
      
      <div className="chat-dropdown__content">
        {children}
      </div>
      
      {showFooter && footerContent && (
        <div className="chat-dropdown__footer">
          {footerContent}
        </div>
      )}
    </div>
  );
}

ChatDropdown.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  footerContent: PropTypes.node,
};

ChatDropdown.defaultProps = {
  title: null,
  subtitle: null,
  className: '',
  showHeader: false,
  showFooter: false,
  footerContent: null,
};

export default ChatDropdown;